import { combineReducers } from "@reduxjs/toolkit";
import authSlice from './Slice/SignIn'
import studentSlice from "./Slice/Student/Student";
import addmissionSlice from "./Slice/Addmission/Addmission";
import BlogSlice from "./Slice/Blog/BlogSlice";
import academicSlice from "./Slice/Academic/Academic";
import FacilitiesSlice from "./Slice/Facilities/Facilites";
import MedicalFacilitiesSlice from "./Slice/Medicalfacilites/MedicalFacilites";
import Department from "./Slice/Department/Department";
import aboutSlice from './Slice/About/About';
import contactSlice from "./Slice/Contact/Conact";
import imageSlcice from './Slice/Gallery/Images';
import Press from "./Slice/Gallery/Press";
import Complaint from "./Slice/Complaint/Complaint";
import StudentFeedback from "./Slice/Feedback/StudentFeedback";
import AlumniFeedback from "./Slice/Feedback/AlumniFeedback";
import TeacherFeedback from "./Slice/Feedback/TeacherFeedback";
import ParentsFeedback from "./Slice/Feedback/ParentsFeedback";
import Notification from "./Slice/Notification/Notification";
import Video from "./Slice/Video/Video";
import Course from "./Slice/Academic/Course";
import Form from "./Slice/Feedback/Form";
import Topper from "./Slice/Academic/Topper";
import News from "./Slice/Blog/News";
import Category from "./Slice/Gallery/Category";

const rootReducer = combineReducers({
    signIn: authSlice,
    student: studentSlice,
    addmission: addmissionSlice,
    blog:BlogSlice,
    academic:academicSlice,
    facilities:FacilitiesSlice,
    medicalFacilites:MedicalFacilitiesSlice,
    department:Department,
    about:aboutSlice,
    contact:contactSlice,
    image:imageSlcice,
    press:Press,
    complaint:Complaint,
    studentFeedback:StudentFeedback,
    alumniFeedback:AlumniFeedback,
    teacherFeedback:TeacherFeedback,
    parentsFeedback:ParentsFeedback,
    notification:Notification,
    video:Video,
    course:Course,
    form:Form,
    topper:Topper,
    news:News,
    category:Category
})


export default rootReducer;